import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Form } from 'antd';
import { PitstopModal } from 'shared';
import ContactForm from 'components/Contacts/ContactForm';
import styled from 'styled-components';

const StyledModal = styled(PitstopModal)`
  && {
    .ant-modal-header {
      .ant-modal-title {
        color: #02103d;
      }
    }

    .ant-modal-close {
      color: #02103d;
    }
  }
`;

const ContactFormModal = ({
  modalId,
  title,
  onCancel,
  onSubmit,
  saving,
  defaultData,
  hideFooter,
  disableFields,
  closable,
}) => {
  const [form] = Form.useForm();

  return (
    <StyledModal
      id={modalId}
      title={title}
      footer={null}
      closable={closable}
      afterClose={() => form.resetFields()}
    >
      <Row gutter={[8, 8]}>
        <Col span={24}>
          <ContactForm
            form={form}
            defaultData={defaultData}
            onCancel={onCancel}
            onSubmit={onSubmit}
            saving={saving}
            disableFields={disableFields}
            hideFooter={hideFooter}
          />
        </Col>
      </Row>
    </StyledModal>
  );
};

ContactFormModal.propTypes = {
  modalId: PropTypes.string.isRequired,
  title: PropTypes.string,
  onCancel: PropTypes.func,
  onSubmit: PropTypes.func.isRequired,
  saving: PropTypes.bool.isRequired,
  defaultData: PropTypes.object,
  hideFooter: PropTypes.bool,
  disableFields: PropTypes.array,
  closable: PropTypes.bool,
};

ContactFormModal.defaultProps = {
  title: 'Add Vendor',
  onCancel: () => {},
  saving: false,
  defaultData: {},
  hideFooter: false,
  disableFields: [],
  closable: true,
};

export default ContactFormModal;
